import { render, staticRenderFns } from "./zTom_index.vue?vue&type=template&id=0dfdfad8&scoped=true&"
import script from "./zTom_index.vue?vue&type=script&lang=js&"
export * from "./zTom_index.vue?vue&type=script&lang=js&"
import style0 from "./zTom_index.vue?vue&type=style&index=0&id=0dfdfad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfdfad8",
  null
  
)

export default component.exports